var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecordStart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#28B446"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8906 20.346C26.5371 21.689 24.8667 22.638 21.5257 24.5361C18.296 26.3709 16.6812 27.2884 15.3798 26.9196C14.8418 26.7671 14.3516 26.4776 13.9562 26.0787C13 25.1139 13 23.2426 13 19.5C13 15.7574 13 13.8861 13.9562 12.9213C14.3516 12.5225 14.8418 12.2329 15.3798 12.0804C16.6812 11.7117 18.296 12.6291 21.5257 14.4639C24.8667 16.362 26.5371 17.311 26.8906 18.654C27.0365 19.2084 27.0365 19.7916 26.8906 20.346Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordStart);
export default __webpack_public_path__ + "static/media/record-start.d987e21b1c9872df067eceaeef64c70e.svg";
export { ForwardRef as ReactComponent };